/* eslint-disable jsx-a11y/media-has-caption */
import { PureComponent } from 'react';

import Image from 'Component/Image';
import Link from 'Component/Link';
import { getUrlMedia } from 'Util/Store';
import { appendWithStoreCode } from 'Util/Url';

import './YBCategoryPerfumes.style';

/** @namespace Elganso/Component/YBCategoryPerfumes/Component */
export class YBCategoryPerfumesComponent extends PureComponent {
    renderPerfumesChild(child) {
        const { onPerfumesChildClick, getMediaByID } = this.props;
        const mediaBanner = getMediaByID(child.id);

        if (!mediaBanner.length || !mediaBanner[0].url_cover) {
            return null;
        }

        return (
            <div
              block="YBCategoryPerfumes"
              elem="perfumesChild"
              key={ mediaBanner[0].name }
              onClick={ () => onPerfumesChildClick(child.id) }
              onKeyUp={ () => {} }
            >
                <img src={ mediaBanner[0].url_cover } alt="" />
            </div>
        );
    }

    renderPerfumesVideo() {
        const { getMedia } = this.props;
        const media = getMedia();

        if (media.length) {
            const videos = media.filter((cat) => cat.url_video);
            // TODO Solo mostramos el primer video que encuentra
            if (videos.length) {
                return (
                    <div block="YBCategoryPerfumes" elem="Video" key="videoPerfumes">
                        <video autoPlay loop block="video_perfumes" id={ `video_perfumes_${ videos[0].name}` } playsInline>
                            <source src={ videos[0].url_video } type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                );
            }
        }

        return (<> </>);
    }

    renderPerfumesBlock() {
        const { children } = this.props;
        if (children.length > 0) {
            return (children.map((child) => <div key={ child.id }>{ this.renderPerfumesChild(child) }</div>));
        }

        return (<> </>);
    }

    renderFunAndChic() {
        const {
            isMobile
        } = this.props;

        let urlImageBanner = `${getUrlMedia()}perfumes/fun_and_chic_escritorio.jpg`;
        if (isMobile) {
            urlImageBanner = `${getUrlMedia()}perfumes/fun_and_chic_movil.jpg`;
        }

        return (
            <Link
              block="Perfumes"
              elem="Link_Fun_And_Click"
              to={ appendWithStoreCode('/perfumes/funchic.html') }
            >
                <Image src={ urlImageBanner } alt="Banner Fun And Chic" />
            </Link>

        );
    }

    render() {
        return (
            <div block="YBCategoryPerfumes">
                { this.renderFunAndChic() }
                { this.renderPerfumesBlock() }
                { this.renderPerfumesVideo() }
            </div>
        );
    }
}

export default YBCategoryPerfumesComponent;
